import { TextOpacity } from "../../../../base/styles";
import clsx from "clsx";

export const SelectTextOpacity = ({ title, value, className, onChange }: {
    title: string,
    value?: TextOpacity,
    className?: string,
    onChange: (value?: TextOpacity) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as TextOpacity;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group mb-2")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={TextOpacity.Opacity10}>10 %</option>
                <option value={TextOpacity.Opacity25}>25 %</option>
                <option value={TextOpacity.Opacity50}>50 %</option>
                <option value={TextOpacity.Opacity75}>75 %</option>
            </select>
        </div>
    )
}